import React, { useState, useEffect } from "react";
import { DashboardGrid } from "./DashboardGrid";
import { ExpandedModule } from "./ExpandedModule";
import NavHeightAdjust from "../../components/navbar/NavHeightAdjust";

export const DashboardRedesign = () => {
  const [selectedModule, setSelectedModule] = useState(null);

  // Allows local storage to store the expanded module so we can display it after the back button is clicked.
  useEffect(() => {
    const storedModule = localStorage.getItem("expandedModule");
    if (storedModule) {
      setSelectedModule(storedModule);
    }
  }, []);

  const handleModuleClick = (title) => {
    setSelectedModule(title);
    localStorage.setItem("expandedModule", title);
  };

  const handleCloseModule = () => {
    setSelectedModule(null);
    localStorage.removeItem("expandedModule");
  };

  const modules = [
    {
      title: "Call Center",
      imgRef: "assets/dashboard/module-icon-call-center.png",
    },
    {
      title: "Maintenance Contracts",
      imgRef: "assets/dashboard/module-icon-maintenance.png",
    },
    {
      title: "Inspections & Violations",
      imgRef: "assets/dashboard/module-icon-inspections.png",
    },
    { title: "Invoicing", imgRef: "assets/dashboard/module-icon-invoices.png" },
    {
      title: "Proposals & Jobs",
      imgRef: "assets/dashboard/module-icon-proposals.png",
    },
    { title: "Setup", imgRef: "assets/dashboard/module-icon-setup.png" },
    { title: "Reports", imgRef: "assets/dashboard/module-icon-reports.png" },
    { title: "Admin", imgRef: "assets/dashboard/module-icon-setup.png" },
  ];

  return (
    <NavHeightAdjust>
      <div className="flex mx-10 mt-2">
        {selectedModule && (
          <div className="flex-grow w-1/2">
            <ExpandedModule
              title={selectedModule}
              onClose={handleCloseModule}
            />
          </div>
        )}
        <div
          className={`flex items-center justify-center ${
            selectedModule ? "" : "w-full"
          }`}
        >
          {!selectedModule && (
            <div className="text-6xl font-bold mr-24">
              <h1 className="text-sss-blue">Welcome to</h1>
              <h1 className="text-sss-blue-sel">Site Service Software</h1>
            </div>
          )}
          <div className="h-full">
            <DashboardGrid
              modules={modules}
              onItemClick={handleModuleClick}
              selectedModule={selectedModule}
            />
          </div>
        </div>
      </div>
    </NavHeightAdjust>
  );
};

export default DashboardRedesign;
